import LoginModalContainer from './LoginModalContainer';

export default LoginModalContainer;
